import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const selectVariants = cva(
  "w-full cursor-pointer rounded-lg border bg-white text-sm transition-[border-color,box-shadow] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "border-[#d1d5db] px-3 py-2.5 focus-visible:border-primary",
        filter:
          "border-[#d1d5db] px-3 py-2 text-sm min-w-[100px]",
        staff:
          "w-[60%] max-md:w-full border-[1.5px] border-border px-3 py-2 focus-visible:border-primary",
        native:
          "border-input px-3 py-2.5",
      },
      size: {
        default: "",
        list: "min-h-[150px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Select = React.forwardRef(
  ({ className, variant, size, ...props }, ref) => (
    <select
      className={cn(selectVariants({ variant, size }), className)}
      ref={ref}
      {...props}
    />
  ),
);
Select.displayName = "Select";

export { Select, selectVariants };
